import NavigationCtrl from './NavigationCtrl.js';

export default [() => ({
    restrict: 'E',
    controller: NavigationCtrl,
    controllerAs: '$ctrl'
})];